import { LIST_OPTIONS } from '../../constants/pouchDB';
import { GENERAL_ACTION_TYPES } from '../general';

const initialState = {
    ...LIST_OPTIONS.audios,
    list: []
};

export const ACTION_TYPES = {
    success: 'AUDIOS_FETCH_SUCCESS',
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
    case ACTION_TYPES.success: {
        return {
            ...state,
            list: action.list
        };
    }

    case GENERAL_ACTION_TYPES.authClear: {
        return { ...initialState };
    }

    default: {
        return state;
    }
    }
};

export default reducer;
